import { TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { utcToZonedTime } from 'date-fns-tz';
import { useEffect, useState } from 'react';
import { useTheme } from "@mui/material/styles";

const CustomDatePicker = ({ name, value, format, maxDate, minDate, handleChange, ref, className, componentsProps, disabled, renderInput, onOpen, views, label, sx, disableFuture = false }) => {
    const theme = useTheme();
    const [localTimeZone, setLocalTimeZone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);

    useEffect(() => {
        setLocalTimeZone(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }, []);

    const localDate = value ? utcToZonedTime(value, localTimeZone) : null;

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                label={label}
                className={className}
                inputFormat={format}
                format={format}
                name={name}
                views={views ? views : ['year', 'month', 'day']}
                onOpen={onOpen}
                value={localDate}
                maxDate={maxDate}
                minDate={minDate}
                onChange={handleChange}
                ref={ref}
                componentsProps={componentsProps}
                disabled={disabled}
                disableFuture={disableFuture}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                            borderColor: theme.palette.secondary.main,
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: theme.palette.secondary.main,
                        },
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                        color: theme.palette.secondary.main,
                    },
                    ...sx,
                    "& .MuiIconButton-root": {
                        color: theme.palette.secondary.main,
                    },
                }}
                renderInput={renderInput ? renderInput : (params) => <TextField InputLabelProps={{}} {...params} />}
            />
        </LocalizationProvider>
    );
};

export default CustomDatePicker;